import React from 'react';
import './Hero.css';
import placeholderImage from '../assets/placeholder.webp';

interface HeroProps {
  title?: string;
  image?: string;
  height?: string;
  showScrollIndicator?: boolean;
  useClipPath?: boolean;
  showButton?: boolean;
  buttonText?: string;
  onButtonClick?: () => void;
  chevronLogo?: string;
}

const Hero: React.FC<HeroProps> = ({
  title,
  image = placeholderImage,
  height = '50vh',
  showScrollIndicator = false,
  useClipPath = false,
  showButton = false,
  buttonText = 'Order Online',
  onButtonClick,
  chevronLogo
}) => {
  const heroStyle = {
    height: height,
  };

  const heroImageStyle = {
    clipPath: useClipPath ? 'polygon(0 0, 100% 0, 100% calc(100% - 8vh), 50% 100%, 0 calc(100% - 8vh))' : 'none',
  };

  return (
    <section className={`hero ${useClipPath ? 'hero-with-chevron' : ''}`} style={heroStyle}>
      <div className="hero-image" style={heroImageStyle}>
        <img
          src={image}
          alt="Burbanks Restaurant Hero"
        />
        <div className="hero-overlay"></div>
      </div>
      <div className="hero-content">
        {title && <h1 className="hero-tagline">{title}</h1>}
        {showButton && (
          <div className="hero-button-container">
            <button className="hero-order-button" onClick={onButtonClick}>
              {buttonText}
            </button>
            <div className="hero-badge">Food open late!</div>
          </div>
        )}
      </div>
      {showScrollIndicator && (
        <div className="scroll-indicator">
          <div className="arrow-down"></div>
        </div>
      )}
      {chevronLogo && useClipPath && (
        <div className="chevron-logo">
          <img src={chevronLogo} alt="Burbanks Logo" />
        </div>
      )}
    </section>
  );
};

export default Hero; 